import { api } from '../../../utils';

const baseUrl = '/profiles/temperature';

const profilesApi = {
  getProfiles: () => api.get(baseUrl),

  addProfile: data => api.post(baseUrl, data),

  editProfile: (id, body: { name; baseTemp; prOffTemp }) => api.put(`${baseUrl}/${id}`, body),

  deleteProfile: id => api.delete(`${baseUrl}/${id}`)
};

export default profilesApi;
